document.addEventListener('DOMContentLoaded', () => {
  

  function updateProductHandles() {
  // Check if all required elements are present
  const elements = document.querySelectorAll('.nosto-recs-template-last .nosto-bottom-bar [data-product-handle]');
  if (!elements.length) {
    return; // Exit if elements are not yet loaded
  }

  // Loop through each element and update the data-product-handle attribute
  elements.forEach(element => {
    const fullUrl = element.getAttribute('data-product-handle');
    
    if (fullUrl) {
      const cleanHandle = fullUrl.split('?')[0].split('/').pop();
      element.setAttribute('data-product-handle', cleanHandle);
    }
  });


    
}

// hide quickshop badges logic
function hideQuickShopBadges(){
      const productBadgeContainers = document.querySelectorAll('.quickshop .product-badges');
      
        productBadgeContainers.forEach(container => {
          const badges = container.querySelectorAll('.badge');
          if (badges.length > 1) {
            let highestZIndex = -Infinity;
            let highestZIndexBadge = null;
      
            badges.forEach(badge => {
              const zIndex = parseInt(window.getComputedStyle(badge).zIndex);
              if (!isNaN(zIndex) && zIndex > highestZIndex) {
                highestZIndex = zIndex;
                highestZIndexBadge = badge;
              }
            });
      
            badges.forEach(badge => {
              if (badge !== highestZIndexBadge) {
                badge.style.opacity = '0'; // Adjust opacity value as needed
              }
            });
          }
        });
}


// Wait until all elements are loaded before running the update function
function checkElementsLoaded() {
  const elements = document.querySelectorAll('.nosto-recs-template-last .nosto-bottom-bar');
  if (elements.length && Array.from(elements).every(el => el.offsetParent !== null)) {
    updateProductHandles(); // Run the update function
    window._swat.fetch(function(r) {
      // console.log('window.myWishList', r)
      window.myWishList = r;

      if (window.myWishList.length > 0) {
        document.querySelector('.wishlist-link__bubble').classList.add('wishlist-link__bubble--visible');
      } else {
        document.querySelector('.wishlist-link__bubble').classList.remove('wishlist-link__bubble--visible');
      };

      
        const wishlistButtons = document.querySelectorAll('.wishlist');
        if (wishlistButtons.length == 0) return;

        wishlistButtons.forEach(function(button) {
          const empi = button.getAttribute('data-empi');
          const epi = button.getAttribute('data-epi');
          if (empi || epi) {
            const matching_arr = window.myWishList.filter(i => i.empi == empi || i.epi == epi);
            if (matching_arr.length == 0) return;
            button.classList.add('is-saved');
          }
        })
      
    });
  } else {
    requestAnimationFrame(checkElementsLoaded); // Check again on the next frame
  }
}

// Start the checking process
checkElementsLoaded();

  
  function reinitializeQuickShopSliders() {
    setTimeout(() => {
      const quickShopColorVariantSliders = document.querySelectorAll('.quickshop .product-single__color-variants');
      quickShopColorVariantSliders.forEach((slider) => {
        const colorVariantItems = slider.querySelectorAll('.quickshop .product-single__color-variant');
        if (colorVariantItems.length > 4) {
          const qsflickityInstance = Flickity.data(slider);
          if (qsflickityInstance) {
            qsflickityInstance.destroy();
          }
          new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            prevNextButtons: true,
            draggable: true,
          });
        }
      });

      const quickShopSlideshowSliders = document.querySelectorAll('.quickshop .product-slideshow');
quickShopSlideshowSliders.forEach((slider) => {
  // Measure BEFORE Flickity touches DOM
  const initialHeight = slider.scrollHeight; // full natural height
  slider.style.minHeight = initialHeight + 'px';
  // hide until Flickity is ready

  // Destroy existing instance if any
  const existingInstance = Flickity.data(slider);
  if (existingInstance) {
    existingInstance.destroy();
  }

  // Init Flickity
  const flkty = new Flickity(slider, {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
  });
 setTimeout(() => {
  // After Flickity finishes layout, unlock height + show
  flkty.on('settle', () => {
    
    slider.style.minHeight = ''; // let it resize naturally again
  });

  // Fallback if settle doesn’t trigger (no movement)
  flkty.on('ready', () => {
    
    slider.style.minHeight = '';
  });
  }, 1000); 
});

        const productBadgeContainersQ = document.querySelectorAll('.template-product .product-badges, .quickshop .product-badges');
      
        productBadgeContainersQ.forEach(container => {
          const badges = container.querySelectorAll('.badge');
          if (badges.length > 1) {
            let highestZIndex = -Infinity;
            let highestZIndexBadge = null;
      
            badges.forEach(badge => {
              const zIndex = parseInt(window.getComputedStyle(badge).zIndex);
              if (!isNaN(zIndex) && zIndex > highestZIndex) {
                highestZIndex = zIndex;
                highestZIndexBadge = badge;
              }
            });
      
            badges.forEach(badge => {
              if (badge !== highestZIndexBadge) {
                badge.style.opacity = '0'; // Adjust opacity value as needed
              }
            });
          }
        });
    }, 300); 

    
  }

  function initializeQuickShop() {
    document.querySelectorAll('.mobile-atc-size-drawer').forEach(button => {
            if (button.hasAttribute('data-quickshop-initialized')) {
        return;
      }
      // Mark as initialized
      button.setAttribute('data-quickshop-initialized', 'true');
      button.addEventListener('pointerdown', async (event) => {

        console.log("wowza");
        event.preventDefault();
         const drawer = document.getElementById('quickshop');

        drawer.classList.add('open');
        
        const productHandle = button.getAttribute('data-product-handle');
        if (!productHandle) {
          console.error("Product handle not found.");
          return;
        }
        
        try {
          const response = await fetch(`/products/${productHandle}?view=ajax`);
          if (!response.ok) {
            throw new Error("Failed to fetch product page.");
          }
          
          const productHTML = await response.text();
          const ccartNostoCart = document.querySelector(".js-drawer-open-cart");
          const drawerContent = document.querySelector('.quickshop');
          if (drawerContent) {
            const headerHTML = `
               <div class="quickshop-header">
                    <div class="drawer__close">
                      <button type="button" class="drawer__close-button js-drawer-close">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" xmlns="http://www.w3.org/2000/svg" width="19.799" height="19.799" viewBox="0 0 19.799 19.799">
                          <g id="Group_4" data-name="Group 4" transform="translate(0.707 0.707)">
                            <line id="Line_1" data-name="Line 1" x2="26" transform="translate(0 0) rotate(45)" fill="none" stroke="#222" stroke-width="2"/>
                            <line id="Line_2" data-name="Line 2" x2="26" transform="translate(0 18.385) rotate(-45)" fill="none" stroke="#222" stroke-width="2"/>
                          </g>
                        </svg>
                        <span class="icon__fallback-text">{{ 'cart.general.close_cart' | t }}</span>
                      </button>
                    </div>
                    <div class="h1 site-header__logo" itemscope="" itemtype="http://schema.org/Organization" aria-label="to homepage">
                      <a href="/" itemprop="url" class="site-header__logo-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="98.439" height="26" viewBox="0 0 404.29 98.61"><polygon points="95.05 8.05 112.93 8.05 112.93 98.44 95.05 98.22 95.05 8.05" fill="currentColor"></polygon><path d="M336.18,243h17.93v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86s10.6-17.86,36.25-17.86c37.4,0,43.08,35.8,43.08,36.89v53.66H479l0-49.62s-.95-22.95-26-22.9c-24.85,0-27.52,22.9-27.52,22.9v49.61H407.67l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9l-.06,49.62H336.18Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M306.88,243l-.05,90.39h-18v-8s-13.35,9.15-26.26,8c-1.1-.11-43.47,1.11-44.35-47.13C218,245.49,258.12,243,258.12,243Zm-45.12,17.82s-25.49-2.35-25.71,25.51c1.8,29.34,26.81,28.7,26.81,28.7s22.95,1.9,25.91-21.78V260.86Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M501.08,243.1H519v9.27s9.48-9.54,26.66-9.44c22.42-.1,36,17.86,36,17.86a38.24,38.24,0,0,1,8.73,23.07c0,1.76,0,49.61,0,49.61H572.57l-.06-49.62s-2.37-22.95-26.76-22.9c-24.16,0-26.74,22.9-26.74,22.9L519,333.48H501.08Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M495.61,235l-16.31,0,0,8.81a39.37,39.37,0,0,1,8.22,7.26c1.49,1.82,2.34,1.43,8.07,12.58Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path><path d="M591.18,258.69c0-9.11,6.49-15.76,15.68-15.76s15.6,6.65,15.6,15.76-6.49,15.83-15.6,15.83S591.18,267.8,591.18,258.69Zm4.31,0c0,6.85,4.38,11.65,11.3,11.65s11.37-4.8,11.37-11.65S613.64,247,606.79,247,595.49,251.84,595.49,258.69Zm14.69,1.7,4.33,6.41-4.87.08-3.71-6.18h-1.31v6.18h-4v-16.6H608c3.47,0,5.79,2,5.79,5.17A4.92,4.92,0,0,1,610.18,260.39Zm-5.56-6.49v3.48h3.17a1.77,1.77,0,0,0,2-1.78c0-1.23-.93-1.7-2-1.7Z" transform="translate(-218.18 -234.99)" fill="currentColor"></path></svg> 
                      </a>
                    </div>
                    <div class="drawer__empty-right"></div>
                </div>
            `;
            drawerContent.innerHTML = headerHTML + productHTML;
           
            reinitializeQuickShopSliders();
            hideQuickShopBadges();
            lipscore.reInitWidgets();
            document.querySelectorAll('.size-selector-button').forEach(function(button) {

              button.addEventListener('click', function() {

                theme.SizeGuideModal.open();

              });

            });

            
            // Create and append overlay
            const overlay = document.createElement('div');
            overlay.className = 'quickshop-overlay';
            overlay.style.cssText = `
              width: 100%;
              height: 100%;
              position: fixed;
              background: black;
              left: 50%;
              z-index: 1;
              top: 50%;
              transform: translate(-50%, -50%);
              opacity: 0.3;
            `;
            document.body.appendChild(overlay);

            // Function to close quickshop and remove overlay
            const closeQuickShop = () => {
              const quickshop = document.querySelector('.quickshop');
              if (quickshop) {
                quickshop.innerHTML = '';
                quickshop.style.display = 'none';
              }
              const existingOverlay = document.querySelector('.quickshop-overlay');
              if (existingOverlay) {
                existingOverlay.remove();
              }
            };
            overlay.addEventListener('click', closeQuickShop);

            const closeButton = document.querySelector('.quickshop-header .drawer__close-button');
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                const quickshop = document.querySelector('.quickshop');
                if (quickshop) {
                  quickshop.innerHTML = '';
                  quickshop.style.display = 'none';
                }
                const existingOverlay = document.querySelector('.quickshop-overlay');
                if (existingOverlay) {
                  existingOverlay.remove();
                }
              });
            }
            drawerContent.style.display = 'flex';
            // ccartNostoCart.click();
                // Add event listeners to variant input elements for selection logic
            document.querySelectorAll('.quickshop .variant-input').forEach(input => {
              input.addEventListener('click', () => {
                // Remove .var-inpt-selected from all other variant inputs within the quickshop container
                document.querySelectorAll('.quickshop .variant-input').forEach(el => {
                  el.classList.remove('var-inpt-selected');
                });
                // Add .var-inpt-selected to the clicked variant input
                input.classList.add('var-inpt-selected');
              });
            });
            
            // Add to cart logic
            // document.querySelectorAll('.quickshop .product-single__form .add-to-cart').forEach(button => {
            //   button.addEventListener('click', (event) => {
            //     event.preventDefault(); // Prevent default form submission
                
            //     const form = button.closest('.product-single__form');
            
            //     // Get the selected variant ID
            //     const selectedVariant = form.querySelector('.var-inpt-selected');
            //     if (!selectedVariant) {
            //       console.error('No variant selected');
            //       return;
            //     }
            //     const variantId = selectedVariant.getAttribute('data-variant-id');
                         
            //     const ccart = document.querySelector(".js-drawer-open-cart");
            
            //     fetch('/cart/add.js', {
            //       method: 'POST',
            //       headers: {
            //         'Content-Type': 'application/json'
            //       },
            //       body: JSON.stringify({ id: variantId, quantity: 1 })
            //     })
            //     .then(response => response.json())
            //     .then(data => {
            //       console.log('Added to cart');
            //       document.dispatchEvent(new Event('cart:build'));
            //       const quickshop = document.querySelector('.quickshop');
            //       if (quickshop) {
            //         quickshop.innerHTML = '';
            //         quickshop.style.display = 'none';
            //       }
            //       // setTimeout(() => {
    
            //       //   nostojs(function(api) {
            //       //     var request = api.createRecommendationRequest();
            //       //     document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
            //       //       request.addElements([element.id]); 
            //       //     });
            //       //     request.loadRecommendations();
            //       //   });
    
            //       // }, 900); 
            //     })
            //     .catch(error => {
            //       console.error('Error adding to cart:', error);
            //     });
            //   });
            // });

              window._swat.fetch(function(r) {
      window.myWishList = r;

      if (window.myWishList.length > 0) {
        document.querySelector('.wishlist-link__bubble').classList.add('wishlist-link__bubble--visible');
      } else {
        document.querySelector('.wishlist-link__bubble').classList.remove('wishlist-link__bubble--visible');
      };

      
        const wishlistButtons = document.querySelectorAll('.wishlist');
        if (wishlistButtons.length == 0) return;

        wishlistButtons.forEach(function(button) {
          const empi = button.getAttribute('data-empi');
          const epi = button.getAttribute('data-epi');
          if (empi || epi) {
            const matching_arr = window.myWishList.filter(i => i.empi == empi || i.epi == epi);
            if (matching_arr.length == 0) return;
            button.classList.add('is-saved');
          }
        })
      
    });
            

//  function attachAddToCartEvent() {
//  // Remove the existing event listener to prevent multiple bindings
//     const addToCartForm = document.querySelector('.quickshop .combined-product .product-form');
//     const newAddToCartForm = addToCartForm.cloneNode(true);
//     // setTimeout(() => { const newAddToCartForm = addToCartForm.cloneNode(true); /* Your code using newAddToCartForm */ }, 1000);
//     addToCartForm.parentNode.replaceChild(newAddToCartForm, addToCartForm);

//     // Attach the new event listener for form submission
//     newAddToCartForm.addEventListener('submit', function(event) {
//       event.preventDefault(); // Prevent the default form submission behavior

//       // Collect the form data
//       const formData = new FormData(this);

//       // Perform the AJAX request to add the product to the cart
//       fetch('/cart/add.js', {
//         method: 'POST',
//         body: formData,
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest', // Ensure the request is recognized as AJAX
//           'Accept': 'application/json' // Expect a JSON response from Shopify
//         }
//       })
//       .then(response => {
//         // Check if the response is OK, else throw an error
//         if (!response.ok) {
//           throw new Error('Network response was not ok');
//         }
//         return response.json();
//       })
//       .then((data) => {
//         // Successfully added to cart, now open the cart drawer
//         document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: data }})); // Dispatch a custom event to update the cart
        
//         // nostojs(function(api) {
//         //   var request = api.createRecommendationRequest();
//         //   document.querySelectorAll(".nosto-cart-el").forEach(function(element) {
//         //     request.addElements([element.id]); 
//         //   });
//         //   request.loadRecommendations();
//         // });
        
//         const cartDrawer = document.querySelector('.js-drawer-open-cart');
//         if (cartDrawer) {
//           // cartDrawer.click(); // Open the cart drawer if the element exists
//         }
//         const quickshop = document.querySelector('.quickshop');
//                 if (quickshop) {
//                   quickshop.innerHTML = '';
//                   quickshop.style.display = 'none';
//                 }
//         // cartDrawer.click();
//       })
//       .catch(error => {
//         console.error('Error adding item to cart:', error);
//       });
//     });
//        setTimeout(function() {
//           yotpo.refreshWidgets();
//           setTimeout(function() {
//           var recensionerLinks = document.querySelectorAll('.yotpo-sr-bottom-line-text');
//           var reviewFound = false; // Flag to check if any review is found
        
//           recensionerLinks.forEach(function(link) {
//             var reviewText = link.textContent;
//             var reviewNumberMatch = reviewText.match(/\d+/); // Match any number in the text
        
//             if (reviewNumberMatch) {
//               var reviewNumber = parseInt(reviewNumberMatch[0], 10); // Extract and convert the number part to an integer
//               link.innerHTML = `(${reviewNumber})`;
        
//               if (reviewNumber > 0) {
//                 reviewFound = true; // Set flag to true if a review is found
//               }
//             }
//           });
          
//           var yotpoContStars = document.querySelectorAll('.yotpo-sr-bottom-line-summary');
//           yotpoContStars.forEach(function(element) {
//               element.style.opacity = '1';
//           });
//           }, 1500);
//     }, 100); 
//   }
            
    // setTimeout(function() {
    //       yotpo.refreshWidgets();
      
    //       setTimeout(function() {
    //       var recensionerLinks = document.querySelectorAll('.yotpo-sr-bottom-line-text');
    //       var reviewFound = false; // Flag to check if any review is found
        
    //       recensionerLinks.forEach(function(link) {
    //         var reviewText = link.textContent;
    //         var reviewNumberMatch = reviewText.match(/\d+/); // Match any number in the text
        
    //         if (reviewNumberMatch) {
    //           var reviewNumber = parseInt(reviewNumberMatch[0], 10); // Extract and convert the number part to an integer
    //           link.innerHTML = `(${reviewNumber})`;
        
    //           if (reviewNumber > 0) {
    //             reviewFound = true; // Set flag to true if a review is found
    //           }
    //         }
    //       });
          
    //         var yotpoContStars = document.querySelectorAll('.yotpo-sr-bottom-line-summary');
    //         yotpoContStars.forEach(function(element) {
    //             element.style.opacity = '1';
    //         });
    //       }, 500);
    // }, 100); 
            
 function updateProductDetails(productUrl) {
    const newTitle = document.querySelector('.quickshop .product-single__title').textContent;
    document.title = newTitle;
    // attachAddToCartEvent();
    initNoDrawerCheckoutCTA();
  }

 function onVariantChange({ target: optionValueElement }) {

  const productElement = document.querySelector('.quickshop .combined-product');
  const sectionId = document.querySelector('.quickshop #productSection').dataset.sectionId;
  const oldProductUrl = productElement.dataset.productUrl;
  const newProductUrl = optionValueElement.dataset.productUrl;
  const productUrl = newProductUrl ? newProductUrl : oldProductUrl;
  const newVariantId = optionValueElement.dataset.variantId;
  let params = `section_id=${sectionId}&`;
 

  if (newVariantId) {
    params += `variant=${newVariantId}`;
  } else {
    const selectedOptionValues = Array.from(document.querySelectorAll('.quickshop fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
    params += `option_values=${selectedOptionValues}`;
  }

  // Clear selected class from all radio buttons and their parent divs
  document.querySelectorAll('.quickshop variant-input').forEach(div => div.classList.remove('selected'));
  document.querySelectorAll('.quickshop input[type="radio"]').forEach(input => input.classList.remove('selected'));

  // Add selected class to the clicked radio button and its parent div
  optionValueElement.classList.add('selected');
  optionValueElement.closest('.variant-input').classList.add('selected');

  fetch(`${productUrl}?${params}`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      if (newProductUrl && oldProductUrl !== newProductUrl) {
        productElement.parentNode.insertBefore(html.querySelector('.combined-product'), productElement);
        productElement.remove();
     

        // Update the URL and title
        updateProductDetails(newProductUrl);
        reinitializeQuickShopSliders();
       
        document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
          button.addEventListener('click', function() {
            theme.SizeGuideModal.open();
          });
        });

        // Focus on the newly selected option
        document.querySelector(`#${optionValueElement.id}`).focus();

        // Reattach the event listeners for the updated product details
        // attachAddToCartEvent();
        initNoDrawerCheckoutCTA();
        return;
      }

      // // Update option selectors
      document.querySelector('.quickshop .optionValueSelectors').innerHTML = html.querySelector('.optionValueSelectors').innerHTML;

      // Focus on the newly selected option
      document.querySelector(`#${optionValueElement.id}`).focus();

      // Update the price if necessary
      const priceEl = document.querySelector('.quickshop .product__price');
      if (html.querySelector('.product__price')) {
        priceEl.innerHTML = html.querySelector('.product__price').innerHTML;
      } else {
        priceEl.innerHTML = '';
      }

        document.querySelectorAll('.quickshop .size-selector-button').forEach(function(button) {
          button.addEventListener('click', function() {
            theme.SizeGuideModal.open();
          });
        });

    
      
      // Update Add to Cart form with the correct variant ID
      const addToCartForm = document.querySelector('.quickshop .product-form');
      const newVariantInput = html.querySelector('.product-form input[name="id"]');
      addToCartForm.querySelector('.quickshop input[name="id"]').value = newVariantInput.value;
      
    });
   

    
        }
        const quickshopproductSection = document.querySelector('.quickshop #productSection');
        if (quickshopproductSection) {
            quickshopproductSection.addEventListener('change', onVariantChange);
        }
          // attachAddToCartEvent();
          initNoDrawerCheckoutCTA();
          }
        } catch (error) {
          
          console.error("Error loading product page:", error);
        }
      });
    });

  
}

  // Use a MutationObserver to wait for .mobile-atc-size-drawer elements to load
const observer = new MutationObserver((mutationsList, observer) => {
  // Check if .mobile-atc-size-drawer elements are present
  if (document.querySelectorAll('.mobile-atc-size-drawer').length > 0) {
    setTimeout(initializeQuickShop, 500);
    // observer.disconnect(); // Disconnect after initialization
  }
  
  // if (document.querySelectorAll('.template-index .nosto-recs-template-last .mobile-atc-size-drawer').length > 0) {
  //   initializeQuickShop();
  //   observer.disconnect(); // Disconnect after initialization
  // }
  // Loop through mutations to find added .nosto-list-item elements
  mutationsList.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          // Check the node itself or its descendants
          if (node.matches && node.matches('.mobile-atc-size-drawer')) {
            setTimeout(initializeQuickShop, 500);
          } else if (node.querySelectorAll) {
            const newButtons = node.querySelectorAll('.mobile-atc-size-drawer');
            if (newButtons.length > 0) {
              setTimeout(initializeQuickShop, 500);
            }
          }
        }
      });
      setTimeout(() => {
      document.querySelectorAll('.quickshop .sku-container-new .sku-item, .template-cart .nosto-list-item .sku-item, .sku-list-new .sku-item').forEach(item => {
        if (!item.hasAttribute('data-listener-added')) {
          item.setAttribute('data-listener-added', 'true'); // Mark to prevent duplicate listeners
          item.addEventListener('click', () => {
            const variantId = item.getAttribute('data-variant-id');
            const ccart = document.querySelector(".js-drawer-open-cart");

            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            })
            .then(response => response.json())
            .then(data => {
              document.dispatchEvent(new Event('cart:build'));
                    // Inject styles if not already added
  if (!document.querySelector('#cnv-cart-popup-style')) {
  const style = document.createElement('style');
  style.id = 'cnv-cart-popup-style';
  style.textContent = `
    .cnv-cart-popup {
      position: fixed;
      align-items: center;
      justify-content: center;
      flex-direction: row-reverse;
      gap: 2px;
      top: 20px;
      right: 20px;
      background: #fff;
      border: 1px solid #ddd;
      box-shadow: 0 4px 16px rgba(0,0,0,0.15);
      border-radius: 4px;
      padding: 12px;
      max-width: 300px;
      z-index: 9999;
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease, transform 0.3s ease;
      transform: translateY(-10px);
      font-family: inherit;
    }
    .cnv-cart-popup.show {
      display: flex;
      opacity: 1;
      transform: translateY(0);
    }
    .cnv-cart-popup img {
      width: 60px;
      height: auto;
      float: left;
      margin-right: 10px;
      border-radius: 2px;
    }
    .cnv-cart-popup .details {
      overflow: hidden;
      font-size: 12px;
    }
    .cnv-cart-popup .title {
      font-weight: 400;
      margin-bottom: 4px;
    }
    .cnv-cart-popup .checkout-btn {
      display: block;
      text-align: center;
      margin-top: 10px;
      background: #000;
      color: #fff;
      padding: 10px;
      font-weight: 600;
      text-decoration: none;
    }
    .cnv-cart-popup .close-btn {
      position: relative;
      background: none;
      border: none;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
      color: #999;
      padding: 4px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cnv-cart-popup .close-btn:hover {
      color: #333;
    }
  `;
  document.head.appendChild(style);
}

// Create popup container
const popup = document.createElement('div');
popup.className = 'cnv-cart-popup';
document.body.appendChild(popup);

// Function to close popup
function closePopup() {
  popup.classList.remove('show');
  setTimeout(() => (popup.style.display = 'none'), 300);
}

// Function to build and show popup
fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
  .then(r => r.json())
  .then(cart => {
    if (!cart || !cart.items?.length) return;
    const item = cart.items[0]; // Most recent item (Shopify adds newest first)

    popup.innerHTML = `
      <button class="close-btn" aria-label="Close">×</button>
      <div class="details">
        <div class="title">${item.product_title} added to cart.</div>
      </div>
    `;

    // Add click handler to close button
    popup.querySelector('.close-btn').addEventListener('click', closePopup);

    popup.style.display = 'block';
    requestAnimationFrame(() => popup.classList.add('show'));

    // Auto-hide after 5s
    setTimeout(closePopup, 5000);
  })
  .catch(console.error);
           
            })
            .catch(error => {
              console.error('Error adding to cart:', error);
            });
          });
        }
      });
      setTimeout(() => {
      // Update the color count in .colorVariantCount elements
      document.querySelectorAll('.nosto-list-item .colorVariantCount').forEach(element => {
        if (!element.hasAttribute('data-count-updated')) {
          element.setAttribute('data-count-updated', 'true'); // Mark to prevent duplicate processing
          const value = element.textContent || "";
          const colorCount = value.split('|').length;
          if (colorCount > 1){ 
            element.textContent = `Colors +${colorCount - 1}`;
          } else {
            element.textContent = ``;
          }
        }
      });
    }, 600);
    }, 600);
    }
  });
});

// Start observing the document body for added nodes
observer.observe(document.body, { childList: true, subtree: true });


  
});

function updateSniffieOmnibusPrice(variantId) {
  fetch(`/products/{{ product.handle }}?variant=${variantId}`)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newPrice = doc.querySelector('.sniffie-omnibus-price').innerHTML;
      document.querySelector('.sniffie-omnibus-price').innerHTML = newPrice;
    }).catch(error => {
      console.error('Error updating sniffie omnibus price:', error);
    });
}



function initNoDrawerCheckoutCTA() {
  (function() {
  const VER = 'CNV-PDP NoDrawer Checkout CTA v1.6 (Nosto moves after ATC under .under-atc-text)';
  if (window.__cnvNoDrawerCheckoutCTA_v16) {
    console.warn(`[${VER}] already applied`);
    return;
  }
  window.__cnvNoDrawerCheckoutCTA_v16 = true;
  // Utils
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => Array.prototype.slice.call(r.querySelectorAll(s));
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts || false);
  const FORM_SEL = '.product-form, .product-single__form, form[action="/cart/add"]';
  // Styles
  (function injectStyle() {
    if (q('#cnv-nodrawer-style')) return;
    const css = `
      #cnv-checkout-cta { display:none; width:100%; clear:both; margin-top:10px; overflow:hidden; transition:max-height .25s ease; }
      #cnv-checkout-cta.cnv-open { display:block; max-height:160px; }
      #cnv-checkout-cta:not(.cnv-open) { max-height:0; }
      #cnv-checkout-cta .cnv-checkout-btn {
        display:block; width:100%; text-align:center;
        background:#000; color:#fff; border:0; border-radius:0px;
        padding:14px 16px; font-weight:600; cursor:pointer; text-decoration:none;
      }
      #cnv-checkout-cta .cnv-checkout-btn:focus { outline:2px solid #111; outline-offset:2px; }
      .cnv-nosto-below-cta { width:100% !important; display:block !important; clear:both !important; }
    `;
    const s = document.createElement('style');
    s.id = 'cnv-nodrawer-style';
    s.textContent = css;
    document.head.appendChild(s);
  })();
  // Checkout CTA
  function getCheckoutHref() {
    const candidates = [
      '#CartDrawer a[href*="/check"]',
      '.ajaxcart__checkout[href*="/check"]',
      '.mini-cart a[href*="/check"]',
      '.cart__checkout[href*="/check"]',
      'a.btn--checkout[href*="/check"]',
      'a[href^="/checkout"]'
    ];
    for (const sel of candidates) {
      const a = q(sel);
      if (a && a.getAttribute('href')) return a.getAttribute('href');
    }
    return '/cart';
  }
  function ensureCheckoutCTA() {
    const btnWrap = q('.pdp-button-container') || q(FORM_SEL);
    if (!btnWrap) return null;
    let cta = q('#cnv-checkout-cta', btnWrap) || q('#cnv-checkout-cta');
    if (!cta || (cta && cta.parentElement !== btnWrap)) {
      if (cta && cta.parentElement !== btnWrap) {
        btnWrap.appendChild(cta);
      } else if (!cta) {
        cta = document.createElement('div');
        cta.id = 'cnv-checkout-cta';
        const a = document.createElement('a');
        a.className = 'cnv-checkout-btn';
        a.textContent = 'Checkout';
        a.href = getCheckoutHref();
        a.rel = 'nofollow';
        cta.appendChild(a);
        btnWrap.appendChild(cta);
      }
    } else {
      const a = cta.querySelector('.cnv-checkout-btn');
      if (a) a.href = getCheckoutHref();
    }
    return cta;
  }
  function revealCheckoutCTA() {
    const cta = ensureCheckoutCTA();
    if (cta) {
      const a = cta.querySelector('.cnv-checkout-btn');
      if (a) a.href = getCheckoutHref();
      cta.classList.add('cnv-open');
    }
  }
  // Nosto
  function getCandidateNostoEls() {
    const ids = [
   '#productpage_nosto_8', '#productpage-nosto-8', '#productpage-nosto_2', '#pdp-rec-2', '#pdp-rec-1', '#pdp-rec-3', '#pdp-rec-4', 
      '#pdp-rec-5', '.nosto_element#productpage_nosto_8', '.nosto_element#productpage-nosto-2'
    ];
    const found = ids.map(sel => q(sel)).filter(Boolean);
    qa('.product-single__meta .nosto_element').forEach(el => {
      if (!found.includes(el)) found.push(el);
    });
    return found;
  }
  function nostoHasContent(root) {
    if (!root) return false;
    const sel = [
      '.nosto-list-item',
      '.nosto-product',
      '.product, .grid-product, .product-card',
      'img[src], img[data-src], img[data-srcset]',
      'a[href*="/products/"]'
    ].join(',');
    if (root.querySelector(sel)) return true;
    const text = (root.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 80;
  }
  function moveNostoUnderATCTextWhenReady(timeoutMs = 15000) {
    const underAtc = q('.under-atc-text');
    if (!underAtc) return;
    const nostos = getCandidateNostoEls();
    if (!nostos.length) return;
    const doMove = (el) => {
      if (!el) return;
      el.classList.add('cnv-nosto-below-cta');
      underAtc.insertAdjacentElement('afterend', el);
    };
    const ready = nostos.find(n => nostoHasContent(n));
    if (ready) {
      doMove(ready);
      return;
    }
    const observers = [];
    const stopAll = () => observers.forEach(o => o.disconnect());
    nostos.forEach(nosto => {
      const obs = new MutationObserver(() => {
        if (nostoHasContent(nosto)) {
          stopAll();
          doMove(nosto);
        }
      });
      obs.observe(nosto, {
        childList: true,
        subtree: true
      });
      observers.push(obs);
    });
    setTimeout(stopAll, timeoutMs);
  }
  // Variant handling
  function getCurrentVariantId(scope = document) {
    let cand = scope.querySelector('input[type="radio"][data-variant-id].selected') ||
      scope.querySelector('input[type="radio"][data-variant-id]:checked');
    if (cand && cand.getAttribute('data-variant-id')) return cand.getAttribute('data-variant-id');
    const checked = scope.querySelector('input[type="radio"]:checked');
    if (checked) {
      const wrapper = checked.closest('.variant-input');
      if (wrapper && wrapper.getAttribute('data-variant-id')) {
        return wrapper.getAttribute('data-variant-id');
      }
    }
    const selWrap = scope.querySelector('.variant-input.selected');
    if (selWrap && selWrap.getAttribute('data-variant-id')) {
      return selWrap.getAttribute('data-variant-id');
    }
    const sel = scope.querySelector('select[name="id"]');
    if (sel && sel.value) return sel.value;
    const hidden = scope.querySelector('input[name="id"]');
    if (hidden && hidden.value) return hidden.value;
    return null;
  }
  function syncVariantIdIntoForm(form) {
    if (!form) return null;
    const current = getCurrentVariantId(form) || getCurrentVariantId(document);
    if (!current) return null;
    const hidden = form.querySelector('input[name="id"]');
    const select = form.querySelector('select[name="id"]');
    if (hidden && hidden.value !== String(current)) hidden.value = String(current);
    if (select && select.value !== String(current)) select.value = String(current);
    return String(current);
  }
  // ATC UI states
  function setATCStateSuccess(form) {
    const atcBtn = form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]');
    if (!atcBtn) return;
    const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
    atcBtn.classList.add('cnv-atc-success');
    const original = txt.getAttribute('data-default-text') || 'Add to cart';
    txt.setAttribute('data-original-text', original);
    txt.textContent = 'Added to cart';
  }
  function resetATCState(form) {
    const atcBtn = form && (form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]'));
    if (!atcBtn) return;
    atcBtn.classList.remove('cnv-atc-success');
    const txt = atcBtn.querySelector('[id^="AddToCartText-"]') || atcBtn;
    const def = (txt.getAttribute('data-default-text') || txt.getAttribute('data-original-text') || 'Add to cart').trim();
    txt.textContent = def;
    const cta = ensureCheckoutCTA();
    if (cta) cta.classList.remove('cnv-open');
  }
  function refreshCartQuietly() {
    try {
      fetch('/cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(r => r.ok ? r.json() : null)
        .then(cart => {
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: {
              cart
            }
          }));
          document.dispatchEvent(new CustomEvent('cart:build', {
            detail: {
              cart
            }
          }));
        })
        .catch(() => {});
    } catch (e) {}
  }
  // Drawer guard
  let guardUntil = 0;
  function armDrawerGuard(ms = 5000) {
    guardUntil = Date.now() + ms;
  }
  const CART_OPEN_SEL = [
    '.js-drawer-open-cart', '[data-action="open-drawer"]', '[data-drawer="cart"]',
    '[data-drawer-trigger="cart"]', '.cart-toggle', '.header-cart', '.site-header__cart-toggle'
  ].join(',');
  on(document, 'click', function(e) {
    const tgt = e.target && e.target.closest && e.target.closest(CART_OPEN_SEL);
    if (!tgt) return;
    if (Date.now() < guardUntil) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
  }, true);
  // Submit interception
  on(document, 'submit', function(e) {
    const form = e.target;
    if (!form || !form.matches(FORM_SEL)) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    const currentVariantId = syncVariantIdIntoForm(form);
    if (!currentVariantId) return;
    armDrawerGuard(5000);
    const atcBtn = form.querySelector('.add-to-cart, .combined-atc-btn, button[name="add"]');
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');
    }
    const fd = new FormData(form);
    fd.set('id', String(currentVariantId));
    fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(() => {
        setATCStateSuccess(form);
        revealCheckoutCTA();
        moveNostoUnderATCTextWhenReady(); // move after ATC only after add
        refreshCartQuietly();
        
      })
      .catch(err => {
        console.error('[NoDrawer] ATC error', err);
      })
      .finally(() => {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-busy');
        }
      });
  }, true);
  // Observe DOM (variant swaps, PJAX, async Nosto)
  (function observeProductArea() {
    const root = q('#productSection') || q('.combined-product') || q('.product-single__meta') || document.documentElement;
    const mo = new MutationObserver(() => {
      const form = q(FORM_SEL);
      if (form) syncVariantIdIntoForm(form);
      ensureCheckoutCTA();
    });
    mo.observe(root, {
      childList: true,
      subtree: true
    });
  })();
  // Variant change resets
  (function bindVariantReset() {
    const container = q('#productSection') || q('.product-single__meta') || document;
    on(container, 'change', function(e) {
      if (!e.target) return;
      if (e.target.matches('input[type="radio"], select')) {
        const form = q(FORM_SEL);
        syncVariantIdIntoForm(form);
        resetATCState(form);
        ensureCheckoutCTA();
      }
    }, true);
    on(document, 'variant:change', function() {
      const form = q(FORM_SEL);
      syncVariantIdIntoForm(form);
      resetATCState(form);
      ensureCheckoutCTA();
    });
    on(document, 'variantSwitched', function() {
      const form = q(FORM_SEL);
      syncVariantIdIntoForm(form);
      resetATCState(form);
      ensureCheckoutCTA();
    });
  })();
  // Boot
  (function boot() {
    const form = q(FORM_SEL);
    if (form) syncVariantIdIntoForm(form);
    ensureCheckoutCTA();
  })();


})();
}
